import { useSearch } from 'wouter'
import { useCasquette } from '../../contexts/casquette'
import { useActionsPortail } from '../../contexts/navigation'
import RinaContextCard from '../../components/RinaContextCard'
import PageHub from '../../components/PageHub'
import AideFaqPage from './AideFaqPage'
import { ROUTES } from '../../routes'

/** Page « Questions frequentes » (S56) : /account/aide/faq?q=<id a deplier>. */
export default function PageAideFaq() {
  const { hubMode } = useCasquette()
  const actions = useActionsPortail()
  const questionOuverte = new URLSearchParams(useSearch()).get('q')
  /** Suit le CTA d'une reponse : sous-vue du Compte, onglet du hub, module. */
  const suivreCta = (cta) => {
    if (!cta) return
    if (cta.vue) { actions.ouvrirCompte(cta.vue); return }
    if (cta.tab) { actions.setHubTab(cta.tab); return }
    if (cta.module === 'marche') { hubMode === 'producer' ? actions.ouvrirMarcheProducteur() : actions.setHubTab('explore') }
    else if (cta.module === 'paniers') { hubMode === 'producer' ? actions.ouvrirPaniersProducteur() : actions.ouvrirPaniers() }
  }
  return (
    <PageHub retour={{ label: 'Aide', vers: ROUTES.compte.aide }}>
      <div className="animate-fade-up">
        <RinaContextCard title="Questions fréquentes" message="Les réponses les plus demandées, triées pour votre casquette." />
        <AideFaqPage
          tc="text-ink" ts="text-ink/60" cardBg="bg-card border-card-border" hubMode={hubMode}
          questionOuverte={questionOuverte}
          onCta={suivreCta}
        />
      </div>
    </PageHub>
  )
}
